import { createRoute } from "@tanstack/react-router";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { ClientCardView } from "@/pages/ClientCardView";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/clients/$clientId",
  component: ClientCardRoute,
});

function ClientCardRoute() {
  const { clientId } = Route.useParams();
  return (
    <AuthGuard>
      <ClientCardView clientId={clientId} />
    </AuthGuard>
  );
}
